import BasicRouterView from "../../../components/BasicRouterView.vue";

const maquinaRoutes = {
  path: "mqn",
  redirect: { name: "perfis-papeis" },
  meta: {
    label: "Maquina",
    icon: "precision_manufacturing",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "maquina/maquina-listar",
      name: "maquina-listar",
      meta: {
        label: "Listar",
        icon: "list",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/Listar.vue"),
    },
    {
      path: "maquina/maquina-listar-tentativa",
      name: "maquina-listar-tentativa",
      meta: {
        label: "Tentativas Malsucedidas",
        icon: "list",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/Logs.vue"),
    },
    {
      path: "maquina/maquina-detalhes/:id",
      name: "maquina-detalhes",
      meta: {
        label: "Detalhes",
        icon: "list",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/Detalhes.vue"),
    },
    {
      path: "maquina/maquina-telemetria/:maquina",
      name: "maquina-telemetria",
      meta: {
        label: "",
        icon: "",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "perfis" */ "./views/HistoricoTelemetriaMaquina.vue"
        ),
    },
  ],
};

export default maquinaRoutes;
